import { createFileRoute } from '@tanstack/react-router';
import { CityScreen } from '@/features/explore/CityScreen.tsx';
import { q } from '@/lib/queries.ts';

export const Route = createFileRoute('/_app/explore/cities/$slug')({
  loader: ({ context, params }) => context.queryClient.prefetchQuery(q.city(params.slug)),
  component: CityRoute,
});

function CityRoute() {
  const { slug } = Route.useParams();
  return <CityScreen slug={slug} />;
}
